// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const cinderace_gmax: PokeData = {
  "id": 10210,
  "name": "cinderace-gmax",
  "height": 270,
  "weight": 10000,
  "base_experience": 265,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [],
  "moves": [
    "fire-spin",
    "flamethrower",
    "morning-sun",
    "fire-punch",
    "blaze-kick",
    "eruption",
    "fire-fang",
    "sunny-day",
    "magma-storm",
    "fire-ball",
    "ember"
  ],
  "evolution_chain": {
    "id": 431,
    "item": null,
    "species": [
      {
        "name": "scorbunny",
        "order": 813,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "raboot",
        "order": 814,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 813,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "cinderace",
        "order": 815,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 814,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 99,
    "speed": 152,
    "ability_power": 148
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": true,
  "regional_variant": null
} as const;
